import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faCircle,
  faFile,
  faFilePdf,
  faFileArchive,
  faDownload,
  faPlus,
  faStopwatch,
  faPlay,
  faPen,
  faDollarSign,
  faTrash,
  faCalendarDay,
  faTags,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";

const regularIcons = () => {
  return library.add(
    faCircle,
    faFile,
    faFilePdf,
    faFileArchive,
    faDownload,
    faPlus,
    faStopwatch,
    faPlay,
    faPen,
    faDollarSign,
    faTrash,
    faCalendarDay,
    faTags,
    faMagnifyingGlass
  );
};

export default regularIcons;
